import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import ProfilPage from "../ProfilPage/ProfilPage";
import GroupsPage from "../GroupsPage/GroupsPage";
import styles from "./MainPage.module.css";
import SyllabusPage from "../SyllabusPage/SyllabusPage";
import ProjectsPage from "../ProjectsPage/ProjectsPage";
import SorguPage from "../SorguPage/SorguPage";
import TrialLessonsPage from "../TrialLessonsPage/TrialLessonsPage";
import Toolbar from "../../Components/Toolbar/Toolbar";

const MainPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(() => {
    const saved = localStorage.getItem("teacher_sidebar_open");
    return saved !== null ? JSON.parse(saved) : false;
  });

  const pathParts = location.pathname.split("/");
  const activePage = pathParts[2] || "profil";

  const toggleSidebar = () => {
    setIsOpen((prev) => {
      const next = !prev;
      localStorage.setItem("teacher_sidebar_open", JSON.stringify(next));
      return next;
    });
  };

  const handlePageChange = (page) => {
    navigate(`/main/${page}`);
  };

  return (
    <div className={`d-flex ${styles.mainWrapper}`} style={{ height: "100vh", overflow: "hidden" }}>  {/* minHeight → height, overflow:hidden əlavə et */}
      <Sidebar 
        activePage={activePage} 
        setActivePage={handlePageChange} 
        isOpen={isOpen} 
        toggleSidebar={toggleSidebar} 
      />

      {isOpen && (
        <div 
          className="d-md-none position-fixed w-100 h-100" 
          style={{ background: "rgba(0,0,0,0.5)", zIndex: 998, top: 0, left: 0 }}
          onClick={toggleSidebar}
        />
      )}

      <div className={`${styles.contentWrapper} d-flex flex-column`} style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
        <Header toggleSidebar={toggleSidebar} />

        <div className="flex-fill" style={{ overflowY: "auto", minHeight: 0, padding: "48px 20px 20px" }}>
          <Routes>
            <Route path="profil" element={<ProfilPage />} />
            <Route path="groups" element={<GroupsPage />} />
            <Route path="syllabus" element={<SyllabusPage />} />
            <Route path="sorgu" element={<SorguPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="trial-lessons" element={<TrialLessonsPage />} />
            <Route path="/" element={<Navigate to="profil" replace />} />
          </Routes>
        </div>
      </div>

      <Toolbar />
    </div>
  );
};

export default MainPage;